import React from "react";
import styled from "styled-components";
import { StrategymapConfigHeader } from "./StrategymapConfigHeader";
import { StrategymapInfo } from "./StrategymapInfo";
import { LinkageSection } from "./LinkageSection";
import { useRouteMatch, Route, useParams } from "react-router-dom";
import { SCORECARD_URL, STRATEGYMAP_URL } from "../../../api/urls";
import { GetHook } from "../../../api/api";
import { get } from "../../../utils/get";

export const StrategymapConfig = () => {
  const { path, url } = useRouteMatch();
  const params = useParams();
  const { data: strategymap, error, pending } = GetHook(
    `${STRATEGYMAP_URL}/${get(params, "strategymapId")}`
  );

  return (
    <StrategymapConfigContainer>
      {/* <StrategymapConfigHeader /> */}
      <StrategymapInfo strategymapData={strategymap} />
      <LinkageSection scorecard_id={get(strategymap, "[0]scorecard_id")} />
    </StrategymapConfigContainer>
  );
};

const StrategymapConfigContainer = styled.div`
  background-color: #fff;
  display: grid;
  grid-template-rows: 10em auto;
`;
